import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src-adisco/services/common.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
  selector: 'app-detail-member',
  templateUrl: './detail-member.component.html',
  styleUrls: ['./detail-member.component.css']
})
export class DetailMemberComponent implements OnInit {
  detailMember!: any;
  listIdContact: any[] = [];
  contactData: any[] = [];
  idMember!: any;
  logo = 'src-adisco/assets/images/image-default.jpeg'
  constructor(private dynamicDocumentService: DynamicDocumentService,
    private _activeRouter: ActivatedRoute,
    private _commonService: CommonService,

  ) { }

  ngOnInit() {
    this.getParamUrl()
    this.getDetailMember();
  }
  getParamUrl(): void {
    this.idMember = '' + this._activeRouter.snapshot.paramMap.get('id');
  }
  getDetailMember(): void {
    this.dynamicDocumentService
      .find({
        collectionName: 'dynamic_legal_entity',
        filters: [
          {
            fieldName: 'typeOfLegalEntity',
            conditions: [
              {
                type: 'EQUALS',
                value: 'ADHERENT',
              },
            ],
          },
          {
            fieldName: 'Status',
            conditions: [
              {
                type: 'EQUALS',
                value: 'Publié',
              },
            ],
          },
          {
            "fieldName": "code",
            "conditions": [
              {
                "type": "EQUALS",
                "value": this.idMember
              }
            ]
          }
        ],
        page: 1,
        pageSize: 150
      })
      .subscribe((res: any) => {
        this.detailMember = res.content[0];
        if(this.detailMember.logo) {
          this.logo = this.detailMember?.logo[0]?.url;
        }
        this.detailMember?.linkToNaturalPersons.forEach((itemContact: any) => {
          this.listIdContact.push(itemContact?.documentId);
        });
        this.getContact(this.listIdContact);
      });
  }
  getContact(ids: any): void {
    this._commonService.listContact(ids).subscribe({
      next: (res) => {
        this.contactData = res;
      },
      error: (error) => { },
    });
  }
}
